<template>
  <button
    v-if="group !== 'ungrouped'"
    type="button"
    :aria-expanded="isGroupOpen"
    class="mb-2 flex w-full cursor-pointer flex-row rounded-md py-2 pl-2 text-left text-xs text-neutral-500 transition-colors duration-150 ease-out-quart hover:text-primary-500"
    :class="{
      'active-menu-item': !isGroupOpen && isActiveRouteInGroup
    }"
    @click="doToggleGroup"
  >
    <span class="flex-1">
      {{ t(group) }}
    </span>
    <div class="flex flex-col justify-center pr-4">
      <font-awesome-icon
        :icon="['far', 'chevron-down']"
        class="transition-transform duration-200 ease-out-quart motion-reduce:transition-none"
        :class="{ 'rotate-180': !isGroupOpen }"
      />
    </div>
  </button>
  <div
    class="grid transition-[grid-template-rows] duration-200 ease-out-quart motion-reduce:transition-none"
    :class="isGroupOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
    :inert="!isGroupOpen"
  >
    <div class="min-h-0 overflow-hidden">
      <div class="flex flex-col gap-1">
        <NavigationSideBarItem
          v-for="(item, i) in groupItems"
          :key="`${item.name}-${i}`"
          v-permission="{ ids: item.permissionIds, check: item.permissionCheck }"
          :name="item.name"
          :icon="item.icon"
          :to="item.to"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { vPermission } from '@infuse/iam/permission/directives';
import { MenuItem } from '@infuse/ui/domain';
import { useI18n } from 'vue-i18n';
import NavigationSideBarItem from './NavigationSideBarItem.vue';
import { useNavigationStore } from '@infuse/ui/stores';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const navigationStore = useNavigationStore();
const route = useRoute();

const { t } = useI18n();

interface Props {
  group: string;
  groupItems: MenuItem[];
}

const props = defineProps<Props>();

const isGroupOpen = computed(() => !navigationStore.groupClosed.includes(props.group));
const isActiveRouteInGroup = computed(() =>
  props.groupItems.some((item) => route.matched.some((matchedRoute) => matchedRoute.path === item.to))
);

function doToggleGroup() {
  navigationStore.toggleGroup(props.group);
}
</script>
